module.exports = __webpack_public_path__ + "img/9.72c35092.jpg";